import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { NgIcon } from '@ng-icons/core';
import { LibSharedCommonModule } from '@solvace/common';
import { SvcActionplanComponent } from '@solvace/feature/general/svc-actionplan/svc-actionplan.component';
import { SvcActionPlanList } from '@solvace/feature/general/svc-actionplan/shared/interfaces/svc-actionplan-list.interface';
import { resolveStatusPillClass } from '@solvace/feature/general/svc-action-plan-search-revamp/shared/utils/actionplan-status.utils';
import { SvcModalActionPlanStatusLabelById } from '@solvace/feature/modals/svc-modal-action-plan/shared/enums/svc-modal-action-plan-status.enum';
import { ISvzUserAvatar, UserAvatarSize } from '@solvace/zard/svz-user-avatar/interfaces/svz-user-avatar.interface';
import { SvzUserAvatarComponent } from '@solvace/zard/svz-user-avatar/svz-user-avatar.component';
import { SvzStatusBadgeComponent } from '@solvace/zard/svz-status-badge/svz-status-badge.component';
import { SvzSearchFieldComponent } from '@solvace/zard/svz-search-field/svz-search-field.component';
import { SvzPaginateComponent } from '@solvace/zard/svz-paginate/svz-paginate.component';
import { SvzSkeletonComponent } from '@solvace/zard/svz-skeleton/svz-skeleton.component';
import { provideSolvaceIcons } from '@solvace/zard/svz-icons/solvace-icons';

export interface AlertRecordPlanRow {
  plan: SvcActionPlanList;
  restricted: boolean;
  delay: string;
  responsible: ISvzUserAvatar;
  statusLabel: string;
  statusPillClass: string;
}

@Component({
  selector: 'app-alert-record-action-plans',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './alert-record-action-plans.component.html',
  imports: [
    TranslocoModule,
    NgIcon,
    LibSharedCommonModule,
    SvzUserAvatarComponent,
    SvzStatusBadgeComponent,
    SvzSearchFieldComponent,
    SvzPaginateComponent,
    SvzSkeletonComponent,
  ],
  providers: [provideSolvaceIcons()],
})
export class AlertRecordActionPlansComponent extends SvcActionplanComponent {
  private planRowsCache: { source: SvcActionPlanList[]; rows: AlertRecordPlanRow[] };

  public get canAddPlan(): boolean {
    return this.showButtonAddActionplan && !this.isViewMode;
  }

  public get planRows(): AlertRecordPlanRow[] {
    if (this.planRowsCache?.source !== this.actionsPlans) {
      this.planRowsCache = { source: this.actionsPlans, rows: (this.actionsPlans ?? []).map((plan) => this.toRow(plan)) };
    }
    return this.planRowsCache.rows;
  }

  private toRow(plan: SvcActionPlanList): AlertRecordPlanRow {
    return {
      plan,
      restricted: !!plan.classified && !plan.allowed,
      delay: this.getDelayedDaysLabel(plan),
      responsible: {
        name: plan.senderName,
        picture: plan.senderPicture,
        initialsColor: '#e6e6ea',
        initialsTextColor: '#444',
        size: UserAvatarSize.Table,
        initialsFontSize: 8,
        showBorder: false,
      },
      statusLabel: SvcModalActionPlanStatusLabelById[plan.statusId],
      statusPillClass: resolveStatusPillClass(plan.statusId),
    };
  }
}
